<script>
import moment from "moment-timezone";
import {GET_SLOT, GET_SLOT_AFTER_OPENING} from "@/core/services/store/tutor/tutor.module";

export default {
  name: "DateTimeOfLesson",
  props: {
    lesson: {
      type: Object,
      default: () => ({
        date: '',
        time: '',
        lessonId: ''
      })
    },
    studentId: {
      type: String | Number,
    }
  },
  data() {
    return {
      date: null,
      time: null,
      pickerOptions: {
        disabledDate(time) {
          return moment(time).isBefore(moment().startOf("day"));
        }
      },
      loadingSlot: false,
      timeSlots: [],
      flag: false
    }
  },
  methods: {
    async getSlot() {

      this.timeSlots = []
      this.loadingSlot = true
      let payload = {
        day: this.lesson.date,
        user_id: this.studentId
      }
      try {
        const data = await this.$store.dispatch(GET_SLOT_AFTER_OPENING, payload)
        if (data?.data?.slots.length) {
          const now = Date.now();

          [
            { code: 'morning', name: 'Buổi sáng' },
            { code: 'afternoon', name: 'Buổi chiều' },
            { code: 'evening', name: 'Buổi tối' }
          ].forEach(shift => {
            this.timeSlots.push({
              code: shift.code,
              name: shift.name,
              slots: data.data.slots
                  .filter(s => s.code === shift.code)
                  .map(slot => ({
                    ...slot,
                    start: this.formatTime(slot.start),
                    disable: new Date(slot.start).getTime() < now // thêm trường disable
                  }))
            })
          })
        }
      } catch (e) {
        this.$message({
          showClose: true,
          message: `${e?.response.data.message || 'Có lỗi xảy ra'}`,
          type: 'error'
        });
      } finally {
        this.loadingSlot = false
      }


    },
    formatTime(isoString, timezone = 'Asia/Ho_Chi_Minh') {
      return moment.tz(isoString, timezone).format('HH:mm:ss');
    }
  },
}
</script>

<template>
  <div class="row ">
    <div class="col-md-6 mb-3">
      <label>Ngày học {{ lesson?.lessonId }} <span class="text-danger">*</span></label>
      <ValidationProvider :name="`Ngày học ${lesson?.lessonId}`" rules="required" v-slot="{ errors }">
        <el-date-picker v-model="lesson.date" type="date" class="w-100" placeholder="Chọn ngày" format="dd-MM-yyyy"
                        value-format="yyyy-MM-dd" :picker-options="pickerOptions"/>
        <small class="text-danger">{{ errors[0] }}</small>
      </ValidationProvider>
    </div>
    <div class="col-md-6 mb-3">
      <label>Giờ học {{ lesson?.lessonId }} <span class="text-danger">*</span></label>
      <ValidationProvider :name="`Giờ học ${lesson?.lessonId}`" rules="required" v-slot="{ errors }">
        <el-select
            v-model="lesson.time"
            placeholder="Chọn giờ học"
            class="w-100"
            clearable
            filterable
            :loading="loadingSlot"
            @focus="getSlot()"
            :disabled="!lesson.date"
        >
          <el-option-group
              v-for="group in timeSlots"
              :key="group.code"
              :label="group.name">
            <el-option
                v-for="item in group.slots"
                :key="item.start"
                :label="item.start"
                :value="item.start"
                :disabled="item.disable">
            </el-option>
          </el-option-group>
        </el-select>
        <small class="text-danger">{{ errors[0] }}</small>
      </ValidationProvider>
    </div>
  </div>
</template>

<style scoped>

</style>